import script from "./ProjectsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsBlockPanelList.vue?vue&type=style&index=0&id=1582a270&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1582a270"]])

export default __exports__